module.exports = __webpack_public_path__ + "static/media/filter-applied-icon.741cdcb3.svg";